





    import Vue from 'vue';
    import Component from 'vue-class-component';

    @Component({
        name: "agreement",
        components: {},
        mixins:[]
    })
    export default class agreement extends Vue {
        public created():void {
            // on componenet created
        }
        public mounted():void {
            // on componenet mounted
        }
    }
